import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const AccountDropdown = props => {
  const { clientInfo, signoutUser } = props;
  const { t } = useTranslation('pageHeader');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="account-dropdown dropdown" ref={dropdownRef}>
      <button 
        className="account-dropdown__trigger dropdown__trigger" 
        onClick={toggleDropdown}
        type="button"
      >
        <img src={clientInfo.picture} alt="avatar" className="account-dropdown__account-image" />
      </button>
      {isOpen && (
        <div className="account-dropdown__content dropdown__content">
          <div className="account-header">
            <div className="account-header__profile">
              <img src={clientInfo.picture} alt="avatar" className="account-profile__image" />
              <div>
                <span className="account-profile__name">{clientInfo.given_name} {clientInfo.family_name}</span>
                <span className="account-profile__email">{clientInfo.email} </span>
              </div>
            </div>
            <button className="btn btn--secondary btn--block" onClick={signoutUser}>{t('logout')}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountDropdown;
